export const userDummyData = {
  users: [
    {
      id: 1,
      first_name: "John",
      last_name: "Doe",
      dob: "12/12/1999",
      national_Id: "IND123456789",
      gender: "Male",
      phone: "1234567890",
      address: "Aareymilk Colony, Goregaon East Agripada, 400011, Mumbai",
      email: "JohnDoe@gmail.com",
      records: [
        {
          test_date: "12/12/2021",
          test_name: "Covid-19",
          risk_rating: "04",
          patient_name: "Test Name",
          patient_id: "IND123456789",
          id: "1",
          nurse_name: "Nurse 1",
        },
        {
            test_date: "13/12/2021",
            test_name: "Flu",
            risk_rating: "03",
            patient_name: "Test Name 2",
            patient_id: "IND987654321",
            id: "2",
            nurse_name: "Nurse 1.1",
        },
        {
            test_date: "14/12/2021",
            test_name: "Diabetes",
            risk_rating: "05",
            patient_name: "Test Name 3",
            patient_id: "IND876543210",
            id: "3",
            nurse_name: "Nurse 1.2",
        },
      ],
    },
    {
      id: 2,
      first_name: "Jane",
      last_name: "Smith",
      dob: "11/11/1990",
      national_Id: "IND987654321",
      gender: "Female",
      phone: "0987654321",
      address: "Some Address, Mumbai",
      email: "JaneSmith@gmail.com",
      records: [
        {
          test_date: "12/12/2022",
          test_name: "Foot Test",
          risk_rating: "02",
          patient_name: "Test Name",
          patient_id: "IND987654321",
          id: "2",
          nurse_name: "Nurse 2",
        },
        {
            test_date: "13/12/2021",
            test_name: "Flu",
            risk_rating: "03",
            patient_name: "Test Name 2",
            patient_id: "IND987654321",
            id: "2",
            nurse_name: "Nurse 2.2",
        },
        {
            test_date: "14/12/2021",
            test_name: "Diabetes",
            risk_rating: "05",
            patient_name: "Test Name 3",
            patient_id: "IND876543210",
            id: "3",
            nurse_name: "Nurse 2.3",
        },
      ],
    },
    {
      id: 3,
      first_name: "Alice",
      last_name: "Johnson",
      dob: "10/10/1981",
      national_Id: "IND876543210",
      gender: "Female",
      phone: "0876543210",
      address: "Another Address, Mumbai",
      email: "AliceJohnson@gmail.com",
      records: [
        {
          test_date: "12/12/2023",
          test_name: "Eye Test",
          risk_rating: "06",
          patient_name: "Test Name",
          patient_id: "IND876543210",
          id: "3",
          nurse_name: "Nurse 3.1",
        },
        {
            test_date: "13/12/2021",
            test_name: "Flu",
            risk_rating: "03",
            patient_name: "Test Name 2",
            patient_id: "IND987654321",
            id: "2",
            nurse_name: "Nurse 3.2",
        },
        {
            test_date: "14/12/2021",
            test_name: "Diabetes",
            risk_rating: "05",
            patient_name: "Test Name 3",
            patient_id: "IND876543210",
            id: "3",
            nurse_name: "Nurse 3.3",
        },
      ],
    },
  ],
};

export default userDummyData;
